export default __webpack_public_path__ + "static/bomb-c236c62eda8e68bafe77d466ca90d8a7.png";